import http from "@/shared/axios-config/g-http-metodos";

function gerarNovoPedido(novoPedido){
    const { res, erro, requisicao } = http.post('pedido/gerarNovoPedido', novoPedido);
    return { res, erro, requisicao };
}


function postProdutoCarregamento(pedidoId, produtoCarregamento){
    const { res, erro, requisicao } = http.post(`pedido/PostProdutoCarregamento/${pedidoId}`, produtoCarregamento);
    return { res, erro, requisicao };
}

function GetExpedidosOuFaturadosByFiltro(filtros) {
    const { res, erro, requisicao } = http.postArray('pedido/GetExpedidosOuFaturadosByFiltro', filtros)
    return { PedidosCanceladosLiquidadosArray: res , erro, requisicao }
}

function GetInformacaoTipoPedidoEnum() {
    const { res, erro, requisicao } = http.getArray('pedido/GetTipoPedidoEnum')
    return { TipoPedidoArray: res, erro, requisicao }
}

function DeletarPedidoDigitacao(pedidoId){
    const { res, erro, requisicao } = http.post(`pedido/DeletarPedidoDigitacao/${pedidoId}`);
    return { Sucesso: res, erro, requisicao };
}

function GetNomeEmpresaByPedidoId(pedidoId){
    const { res, erro, requisicao} = http.get(`Pedido/GetNomeEmpresaByPedidoId/${pedidoId}`)
    return {NomeEmpresa: res, erro, requisicao}
  }

const PedidoController = {
    gerarNovoPedido,
    postProdutoCarregamento,
    GetExpedidosOuFaturadosByFiltro,
    GetInformacaoTipoPedidoEnum,
    DeletarPedidoDigitacao,
    GetNomeEmpresaByPedidoId
};

export default PedidoController;
